// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Substory__substoryBody___1QDVK{padding-bottom:8px}.Substory__substoryHighlight___95XE1{background:#fff7e9;border-color:#ffd37b}\n", ""]);
// Exports
exports.locals = {
	"substoryBody": "Substory__substoryBody___1QDVK",
	"substoryHighlight": "Substory__substoryHighlight___95XE1"
};
module.exports = exports;
